import React from "react";

function Loading() {
  return (
    <div className="tre-loading-wrap">
        <div className="typing-indicator">
        <div className="typing-circle" />
        <div className="typing-circle" />
        <div className="typing-circle" />
        <div className="typing-shadow" />
        <div className="typing-shadow" />
        <div className="typing-shadow" />
        </div>
    </div>
  );
}

export default Loading;
